<template>
  <div>
    <vue-modal
      v-if="this.$root.$data.create_task_modal_show==true"
      modal_title="Get Quotes"
      container_style="min-width:60%;height:500px;overflow:hidden;text-align:left;"
      body_container_style="min-width:60%;height:500px;overflow:hidden;padding:0;"
      @close="hide"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <create-task @getStep="getStep"></create-task>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </vue-modal>
  </div>
</template>

<script>
import VueModal from "./../../VueModal";
import CreateTask from "./CreateTask";
export default {
  components: {
    VueModal,
    CreateTask
  },
  name: "create-task-modal",

  methods: {
    show() {
      this.$root.$data.create_task_modal_show = true;
    },
    hide() {
      this.$root.$data.create_task_modal_show = false;
    },
    getStep(step) {
      this.step = step;
    }
  },
  data() {
    return {
      isModalVisible: false,
      step: null
    };
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
